/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {AccountAnalyticsSummaryModel} from "../../models/account-analytics-summary-model";

export interface AccountAnalyticsSummaryGetParams {
    accountGuid: string;
}

export function accountAnalyticsSummaryGet(http: HttpClient, rootUrl: string, params: AccountAnalyticsSummaryGetParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<AccountAnalyticsSummaryModel>> {
    const rb = new RequestBuilder(rootUrl, accountAnalyticsSummaryGet.PATH, 'get');
    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }
    if (params) {
        rb.path('accountGuid', params.accountGuid, {"style":"simple"});
    }
    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<AccountAnalyticsSummaryModel>;
        })
    );
}

accountAnalyticsSummaryGet.PATH = '/api/v1/analytics/accounts/{accountGuid}/summary';
